import { getDashboardTeamsControllerListQueryKey } from "@/api/__generated__/dashboard-teams/dashboard-teams";
import { MessageKey } from "@/i18n";
import {
  TeamExportColumn,
  TeamExportColumnValues,
  TeamJoinedFrom,
  TeamMemberRole,
  TeamsTableColumn,
} from "@/types/team.types";

export const TEAMS_INVALIDATE_KEYS = [getDashboardTeamsControllerListQueryKey()];

export const TEAM_EXPORT_COLUMNS: readonly TeamExportColumn[] = TeamExportColumnValues;

export const TEAM_EXPORT_COLUMN_LABELS: { [key in TeamExportColumn]: MessageKey } = {
  title: "general.columns.title",
  sport: "team.export.columns.sport",
  country: "general.columns.country",
  clubId: "team.export.columns.clubId",
  clubName: "team.export.columns.clubName",
  captainId: "team.export.columns.captainId",
  captainFullName: "team.export.columns.captainFullName",
  email: "general.columns.email",
  phone: "general.columns.phone",
  website: "team.export.columns.website",
  membersCount: "team.export.columns.membersCount",
  coaches: "team.export.columns.coaches",
  doctors: "team.export.columns.doctors",
  players: "team.export.columns.players",
  tournamentsCount: "team.export.columns.tournamentsCount",
  createdByFullName: "team.export.columns.createdByFullName",
  createdAt: "general.columns.createdAt",
};

export const TEAMS_TABLE_COLUMN_LABELS: { [key in TeamsTableColumn]: MessageKey } = {
  title: "team.columns.teamName",
  club: "general.columns.club",
  sport: "team.columns.sports",
  contact: "team.columns.contact",
  members: "team.columns.members",
  tournaments: "team.columns.tournaments",
  platform: "club.columns.platform",
  organization: "club.columns.organization",
  joined: "team.columns.joined",
};

export const TEAM_JOINED_FROM_LABELS: { [key in TeamJoinedFrom]: MessageKey } = {
  web: "team.enums.joinedFrom.web",
  mobile: "team.enums.joinedFrom.mobile",
  invite: "team.enums.joinedFrom.invite",
};

export const TEAM_MEMBER_ROLE_LABELS: { [key in TeamMemberRole]: MessageKey } = {
  captain: "team.memberRole.captain",
  coach: "team.memberRole.coach",
  doctor: "team.memberRole.doctor",
  player: "team.memberRole.player",
  playingCaptain: "team.memberRole.playingCaptain",
  staff: "team.memberRole.staff",
};
